import type React from 'react';
import DetailsPanelTabComponent from 'src/Administration/PageContent/PageContentMediaPage/DetailsPanelTab/DetailsPanelTab';
import InfoPanelTabComponent from 'src/Administration/PageContent/PageContentMediaPage/InfoPanelTab/InfoPanelTab';
import TechPanelTabComponent from 'src/Administration/PageContent/PageContentMediaPage/TechPanelTab/TechPanelTab';
import PreviewTabs from 'src/components/Tabs/PreviewTabs/PreviewTabs';
import TabPane from 'src/components/Tabs/TabPane/TabPane';
import styles from './PageContentMediaPageStyles';

const MediaPageComponent: React.FC = () => {
  const classes = styles();
  return (
    <div className={classes.tabWrapper}>
      <PreviewTabs>
        <TabPane name="Info Panel" key="1">
          <InfoPanelTabComponent />
        </TabPane>
        <TabPane name="Details Panel" key="2">
          <DetailsPanelTabComponent />
        </TabPane>
        <TabPane name="Tech Panel" key="3">
          <TechPanelTabComponent />
        </TabPane>
      </PreviewTabs>
    </div>
  );
};

export default MediaPageComponent;
